var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 78,
    viewBox: "0 0 77 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.0013,
    width: 64,
    height: 64,
    rx: 8,
    fill: "#34C347"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bd_1316_17399)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.33337,
    y: 4,
    width: 64,
    height: 64,
    rx: 8,
    fill: "white",
    fillOpacity: 0.3,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6693 37.837V37.8363C36.8868 38.0584 37.0956 38.289 37.295 38.5278C37.0718 38.857 36.8629 39.1967 36.6693 39.546V39.5389C36.245 40.3031 35.8937 41.1133 35.6247 41.9602C34.2026 39.3999 31.471 37.6673 28.3346 37.6673H24.168V34.334H28.3346C31.5998 34.334 34.5517 35.6753 36.6693 37.837ZM40.0026 46.0007V46.0013L40.0026 52.6662L40.0026 52.6673H40.0013H36.6693H36.668V46.0013C36.668 43.8017 37.2767 41.7443 38.3348 39.9883C38.335 39.9886 38.3351 39.9888 38.3353 39.9891C40.3766 36.6004 44.0916 34.334 48.3359 34.334H51.6693V37.6673H48.3359C43.7336 37.6673 40.0026 41.3983 40.0026 46.0007ZM38.3372 37.1834C37.8282 36.6065 37.27 36.0739 36.6693 35.5924V22.667H40.0026V35.5944C39.4028 36.0755 38.8455 36.6073 38.3372 37.1834Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5052 41V31L55.0052 36L47.5052 41Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1693 41V31L21.6693 36L29.1693 41Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3334 26.834L43.3334 26.834L38.3334 19.334L33.3334 26.834Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.83337,
    y: 4.5,
    width: 63,
    height: 63,
    rx: 7.5,
    stroke: "white",
    strokeOpacity: 0.1,
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bd_1316_17399",
    x: -5.66663,
    y: -8,
    width: 88,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1316_17399"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_1316_17399",
    result: "effect2_dropShadow_1316_17399"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1316_17399",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBIcon2);
export default __webpack_public_path__ + "static/media/b_icon-2.4e597d4972e910c91d0667ca084260ef.svg";
export { ForwardRef as ReactComponent };